export default __webpack_public_path__ + "static/media/Honfleur.ec895674.jpg";